module.exports = __webpack_public_path__ + "static/media/thumbnail.f1d6971f.jpg";